import gql from 'graphql-tag'

export const GET_USP_RESULT = gql`
  query GetUspResult {
    usp {
      usps {
        iconId
        text
        link {
          url
          text
        }
      }
    }
  }
`
